const buoySubmarineExchangeList = () => import('Views/buoySubmarineExchange/buoySubmarineExchange-list-new-ui');
const buoySubmarineExchangeMetaData = () => import('Views/buoySubmarineExchange/buoySubmarineExchange-metaData-new-ui');

export default[
  { path: '/buoy-submarine-exchange-list', component: buoySubmarineExchangeList },
  { path: '/buoy-submarine-exchange-metaData/:type/:id', component: buoySubmarineExchangeMetaData },
];



// WEBPACK FOOTER //
// ./src/router/buoySubmarineExchange.js